import type { MouseEvent } from 'react';

export interface SkipLinkProps {
  /** Id of the element to move focus to; it needs `tabIndex={-1}`. */
  targetId: string;
  children: string;
}

/**
 * Bypass-blocks link (WCAG 2.4.1): hidden until it takes keyboard focus, then a
 * row above the header (pushes the page down once, covers nothing).
 */
export function SkipLink({ targetId, children }: SkipLinkProps) {
  function onClick(event: MouseEvent<HTMLAnchorElement>) {
    const target = document.getElementById(targetId);
    if (!target) return;
    // Focus directly instead of leaving a `#hash` entry in the history.
    event.preventDefault();
    target.focus();
  }

  return (
    <a
      href={`#${targetId}`}
      onClick={onClick}
      className="sr-only focus:not-sr-only focus:block focus:bg-base-100 focus:px-4 focus:py-2 focus:text-base-content"
    >
      {children}
    </a>
  );
}
